import './TournamentResult.css'
import { memo, useState, useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import SmoothCollapse from 'react-smooth-collapse'
import { useTranslation } from 'react-i18next'

import { useGetTournamentResultsQuery } from '../../redux/singleTournamentService/singleTournamentApiSlice'
import { ReactComponent as ArrowDown } from '../../icon/arrow-down.svg'

const TournamentResultComponent = (props) => {
	const { t } = useTranslation()
	const { tournamentUid } = useParams()
	const {
		data: tournamentResult = {},
		error,
		isLoading
	} = useGetTournamentResultsQuery({ tournament_uid: tournamentUid })
	const [showParticipantsList, setShowParticipantsList] = useState(true)
	const [resultPlayers, setResultPlayers] = useState([])

	const handleParticipantsList = useCallback(() => {
		setShowParticipantsList(prev => !prev)
	}, [])

	const getSinglePlayerName = (uid) => {
		return props?.tournament?.players?.filter((playersValue) => {
			return playersValue?.uid === uid
		})
	}

	const getDoublePlayerName = (uid) => {
		return props?.tournament?.doubles?.filter((playersValue) => {
			return playersValue?.uid === uid
		})
	}

	useEffect(() => {
		if (Object.keys(tournamentResult).length !== 0) {
			const result = tournamentResult?.nodes.map((tournamentResultValue) => {
				return {
					name: tournamentResultValue?.name,
					player_uid: getSinglePlayerName(tournamentResultValue?.player_uid),
					double_uid: getDoublePlayerName(tournamentResultValue?.double_uid)
				}
			})

			setResultPlayers(result)
		}
	}, [tournamentResult])

	if (error) { console.log(error) }
	if (isLoading) { return <h1>Loading</h1> }

	return (
		<>
			<div className="tournament-result__participants-list">
				<div className="tournament-result__participants-list-header" onClick={handleParticipantsList}>
					<p className="tournament-result__participants-list-title">
						{t('Places')}
					</p>

					<ArrowDown className={showParticipantsList ? 'arrow--up' : 'arrow--down'} />
				</div>

				<SmoothCollapse expanded={showParticipantsList}>
					<div className="tournament-result__participants-list-container">
						{
							resultPlayers?.length !== 0 ?
								resultPlayers?.map((resultPlayersValue, index) =>
									<div className="tournament-result__participants-wrapper" key={index}>
										<div className="tournament-result__participants-list-raiting-container">
											<p className="tournament-result__participants-list-raiting">
												{index + 1}
											</p>
										</div>

										{
											props?.tournament?.players ?
												resultPlayersValue?.player_uid[0] ?
													<p className="tournament-result__participants-list-name">
														{resultPlayersValue?.player_uid[0]?.first_name}
														<span> </span>
														{resultPlayersValue?.player_uid[0]?.last_name}
													</p>
													:
													<p className="tournament-result__participants-list-name">
														{resultPlayersValue?.name}
													</p>
												:
												resultPlayersValue?.double_uid[0] ?
													<p className="tournament-result__participants-list-name">
														<p>
															{resultPlayersValue?.double_uid[0]?.player1?.first_name}
															<span> </span>
															{resultPlayersValue?.double_uid[0]?.player1?.last_name}
														</p>

														<p>
															{resultPlayersValue?.double_uid[0]?.player2?.first_name}
															<span> </span>
															{resultPlayersValue?.double_uid[0]?.player2?.last_name}
														</p>
													</p>
													:
													<p className="tournament-result__participants-list-name">
														{resultPlayersValue?.name}
													</p>
										}
									</div>
								)
								:
								<div className="tournament-result__participants-list">
									<p className="tournament-result__participants-list-name">
										{ t('There are no players yet') }
									</p>
								</div>
						}
					</div>
				</SmoothCollapse>
			</div>

			<div className="tournament-result__description-container">
				<p className="tournament-result__description-title">
					{ t('Description of the tournament') }
				</p>

				<div className="tournament-result__description-block">
					{
						tournamentResult?.report ?
							<p className="description-block__text">
								{tournamentResult?.report}
							</p>
							:
							<p className="description-block__text">
								{ t('No description') }
							</p>
					}
				</div>
			</div>
		</>
	)
}

export const TournamentResult = memo(TournamentResultComponent)
